export const PAGE = 'PAGE';
export const PAGINA = 'PAGINA';
export const EJECUTAR_ACCION = 'EJECUTAR_ACCION';
export const LOAD_DATA = 'LOAD_DATA';

// accion de guardar información en el storage interno
export const estadoPaginaAccion = (data) => ({
  type: PAGINA,
  payload: { data },
});

// ejecutar accion a nivel de base de datos y guardar la informacion correspondiente
export const ejecutarAccion =
  (data, method, URL, llamar) => (dispatch, getState) => {
    if (data) {
      // obtener variables para la validación
      const { unico, clavePagina } = data;
      // en case de existir ya la información en el storage no volver a consultar a la base de datos
      if (unico) {
        const { informacionEstado } = getState().estadoPagina;
        if (informacionEstado[clavePagina]) {
          if (typeof llamar === 'function') {
            llamar(informacionEstado[clavePagina]);
          }
          return null;
        }
      }
    }

    // obtener el token de la sesión del sistema
    const token = window.favia.getTokens();

    // despachar la acción
    return dispatch({
      type: EJECUTAR_ACCION,
      payload: { data, method, URL, token, llamar },
    });
  };

// metodos viejos
export const statusPage = (data) => ({
  type: PAGE,
  payload: { data },
});

export const loadData = (query, method) => (dispatch, getState) => {
  if (query) {
    if (query.unico) {
      const { keyPage } = query;
      const { informacionEstado } = getState().estadoPagina;
      if (informacionEstado[keyPage]) {
        if (informacionEstado[keyPage].datos) {
          if (informacionEstado[keyPage].datos.success) {
            return null;
          }
        }
      }
    }
  }

  const { token } = getState().authUser;
  if (!token)
    return dispatch({
      type: LOAD_DATA,
      payload: { query, method, token: false },
    });
  return dispatch({
    type: LOAD_DATA,
    payload: { query, method, token },
  });
};
